import React from "react";
import Testimonials from "../home/Testimonials";

const FinanceTestimonials = () => {
  return <Testimonials />;
};

export default FinanceTestimonials;
